module.exports = __webpack_public_path__ + "img/clint11.0c12249f.png";